import style from "./TechExperts.module.scss";
import { Banner } from "@/components/common/Banner/Banner";
import { TitleAnimation } from "@/components/common/TitleAnimation/TitleAnimation";

const TechExperts = ({ messages }) => {
  return (
    <section className={`${style.sectionContainer} techExperts`}>
      <div className="container">
        <div className={style.infoContainer}>
          <div className={style.titleContainer}>
            <TitleAnimation
              messages={{
                first_word: messages.first_words,
                second_word: messages.last_word,
              }}
            />
            <p className={style.description}>{messages.description}</p>
          </div>
          <ul className={style.listData}>
            {messages.list_experts.map((item, index) => (
              <li
                key={index}
                className={`${style.listItem} hover-li techHover${[index]}`}
                data-hover={"tech"}
              >
                <h2>{item.number}</h2>
                <span>{item.text}</span>
                <div className={`${style.hoverTextMask} `}>
                  <div className={`${style.hoverText} `}>
                    <p>{item.hoverText}</p>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <Banner words={messages.words_experts} />
    </section>
  );
};

export default TechExperts;

TechExperts.displayName = "TechExperts";
